export default "__VITE_ASSET__t3ZxyIGO__"